import { WarningFilled } from '@ant-design/icons';
import styles from './ConfirmationBanner.module.css';

export default function ConfirmationBanner() {
  return (
    <aside className={styles.banner} role="note">
      <WarningFilled className={styles.icon} aria-hidden />
      <p className={styles.body}>
        <span className={styles.lead}>Before you proceed:</span> All studies
        from both patients will be moved to the primary patient. Notes from both
        records will be combined. The secondary patient will be marked as merged
        and removed from the active list.{' '}
        <strong className={styles.warning}>
          This action cannot be undone.
        </strong>
      </p>
    </aside>
  );
}
